import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import configureStore from './store/configureStore';
import StorageService from './utility/storageService';
import { setAuthInfo } from './store/modules/auth';
import { getAuthPermissions } from './store/modules/accessControl';
import {
  getOrganizationSettings,
  getOrganizationMenuSetup,
  getAllPresets,
} from './store/modules/organizationSettings';
import http, { getHeaders } from './utility/http';
import { API_ME } from './constants/apiRoutes';

const AUTH = 'auth';

const initialState = {};

export const store = configureStore(initialState);

const container = document.getElementById('root');
const root = createRoot(container);

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
};

if (StorageService.has(AUTH)) {
  const auth = JSON.parse(StorageService.get(AUTH));
  http.defaults.headers = getHeaders(StorageService);

  Promise.all([
    http.get(API_ME),
    getAuthPermissions(store.dispatch),
    getOrganizationSettings(store.dispatch),
    getOrganizationMenuSetup(store.dispatch),
    getAllPresets(store.dispatch),
  ]).then(([userData]) => {
    const authInfo = {
      ...auth,
      ...userData.data,
    };
    store.dispatch(setAuthInfo(authInfo));
    StorageService.set(AUTH, JSON.stringify(authInfo));
    renderApp();
  }, renderApp);
} else {
  renderApp();
}
